export const ACME_INSURANCE_RENEWAL_DEMO_ANSWER_INTRO =
  'I pulled together the **Acme Insurance** renewal brief. The key highlights:'

export const ACME_INSURANCE_RENEWAL_DEMO_ANSWER_LIST_ITEMS = [
  'The **$185k renewal** has strong product adoption and remains on track to close.',
  'Security is waiting on confirmation of the SSO enforcement date before procurement can proceed.',
  'Maya is a strong internal champion, while Dana needs a concise executive business case to reinforce sponsorship.',
  'The finance analytics request represents the clearest expansion opportunity following contract signature.',
]

export const ACME_INSURANCE_RENEWAL_DEMO_ANSWER_CLOSING =
  'The brief also includes a stakeholder map, recommended meeting agenda, targeted discussion questions, and a 24-hour follow-up plan.'

/** @returns {object[]} */
export function buildAcmeInsuranceRenewalDemoAnswerBlocks() {
  return [
    { type: 'divider' },
    { type: 'markdown', variant: 'emphasis', content: ACME_INSURANCE_RENEWAL_DEMO_ANSWER_INTRO },
    { type: 'list', variant: 'emphasis', items: ACME_INSURANCE_RENEWAL_DEMO_ANSWER_LIST_ITEMS },
    { type: 'markdown', variant: 'emphasis', content: ACME_INSURANCE_RENEWAL_DEMO_ANSWER_CLOSING },
  ]
}
